export const environment = {
    appVersion: require('../../package.json').version + '-test',
    apiUrl: 'api/api.php',
};
